import React from "react";
import styles from "./styles.module.scss";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

export const Tip = ({ tip, tipTitle }: { tip: string; tipTitle: string }) => {
  return (
    <div className={styles.tip}>
      <h5>{tipTitle}</h5>
      <p>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{tip}</ReactMarkdown>
      </p>
    </div>
  );
};
